/** 可读性优化确认卡：把 slug 显示成小白能懂的页面名。 */

const SLUG_LABELS: Record<string, string> = {
  index: "首页",
  home: "首页",
  about: "关于我们",
  services: "服务",
  contact: "联系我们",
  faq: "常见问题",
  _header: "页头（顶栏）",
  _nav: "导航",
  _footer: "页脚",
  _styles: "全站样式",
};

export function brandSiteScoreOptimizePlanPageLabel(slug: string): string {
  const key = slug.toString().trim().replace(/^\//, "");
  if (!key) return "未命名页面";
  return SLUG_LABELS[key] ?? `「${key}」页`;
}
